<!-- 24猎数据 -->
<template>
  <div class="daData">
    <div class="display_flex">
      <div>
        <div class="today_tabs">
          <span
            @click="
              beal = true;
              agent_change(0);
            "
            :style="is_pro_agent ? 'color:#FFA500' : ''"
            >代理商排行榜</span
          >
          <span
            @click="
              beal = false;
              agent_change(1);
            "
            :style="!is_pro_agent ? 'color:#FFA500' : ''"
            v-if="$cookies.get('auth_grade') == 100"
            >省代排行榜</span
          >
          <el-date-picker
            v-model="picker_tabs"
            type="month"
            style="min-width: 130px; width: 130px"
            placeholder="选择日期"
            value-format="timestamp"
            @change="agent_change()"
          >
          </el-date-picker>
        </div>
        <div
          class="bill"
          v-if="$cookies.get('auth_grade') == 100 || $cookies.get('auth_grade') == 90"
          v-loading="bill_loading"
          element-loading-background="rgba(30, 46, 62, 0.5)"
        >
          <div class="tr">
            <span>排名</span>
            <span>公司</span>
            <span @click="listsort('pay_charge')">工资+服务费</span>
            <span @click="listsort('service_charge')">服务费</span>
            <span @click="listsort('jd_count')">订单数</span>
            <span @click="listsort('man_count')">服务零工人数</span>
            <span @click="listsort('man_hour')">零工服务工时</span>
            <!-- <span @click="listsort(0)">销售额</span> -->
            <!-- <span @click="listsort(1)">合同额</span> -->
            <!-- <span @click="listsort(2)">成交单数</span> -->
          </div>
          <div class="billl">
            <div class="bill_item" v-for="(item, i) in billData" :key="i">
              <p>{{ i + 1 }}</p>
              <p :title="item.agent_company_name">
                {{ item.agent_company_name }}
              </p>
              <p>{{ item.pay_charge }}</p>
              <p>{{ item.service_charge }}</p>
              <p :title="item.jd_count">
                {{ item.jd_count }}
              </p>
              <p :title="item.man_count">
                {{ item.man_count }}
              </p>
              <p>{{ item.man_hour }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-loading="grid_loading" element-loading-background="rgb(30, 46, 62)">
        <!-- <div class="user_data">
          <span v-for="(nub, index) in user_data" :key="index">{{ nub }}</span>
        </div> -->
        <div class="grid-content">
          <div class="user_data">
            <p>零工企业客户数</p><span>{{ map_top.odd_company_count }}</span>
          </div>
          <div class="user_data">
            <p>今日上工人数</p><span>{{ map_top.all_odd_count }}</span>
          </div>
          <div class="user_data">
            <p>今日上工工时</p><span>{{ map_top.all_man_hour }}</span>
          </div>
          <div class="user_data">
            <p>累计上工人数</p><span>{{ map_top.today_odd_count }}</span>
          </div>
          <div class="user_data">
            <p>累计服务工时</p><span>{{ map_top.today_man_hour }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="display_flex">
      <div>
        <div class="today_1">
          <p v-if="$cookies.get('auth_grade') == 90">今日企业数据</p>
          <div class="today_tabs" v-else>
            <span @click="data_change(true)"  :class="{'data_change_color':data_change_is}"
              >今日数据</span
            >
            <span @click="data_change(false)" :class="{'data_change_color':!data_change_is}">30日数据</span>
          </div>
          <div v-if="show2" ref="today_data" class="today_echart"></div>
          <div v-else ref="mouth_data" class="today_echart"></div>
        </div>
        <!-- <div class="today_1 elite" v-if="$cookies.get('auth_grade') == 100">
          <p>精英数据</p>
          <p class="title">今日登录: {{ today_data }}</p>
          <div ref="mouth_elite_data" class="today_echart"></div>
        </div>
        <div class="today_1 elite" v-else>
          <p>30日企业数据</p>
          <div v-if="show2" ref="mouth_data" class="today_echart"></div>
        </div> -->
      </div>

      <div>
        <div class="echarts_r_r">
          <div class="today_tabs">
            <span
              @click="show_change(true)"
              :style="show1 ? 'color:#FFA500' : ''"
              >身份证认证</span
            >
            <span
              @click="show_change(false)"
              :style="!show1 ? 'color:#FFA500' : ''"
              >健康证认证</span
            >
          </div>
          <div class="conent">
            <div v-if="show1" ref="echarts_resume" class="today_echart"></div>
            <div v-else ref="echarts_rader" class="today_echart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import "echarts/map/js/china.js";
import "echarts/map/js/province/jiangxi.js"; //江西省数据js
import "echarts/map/js/province/sichuan.js"; //四川省数据js
import "echarts/map/js/province/jiangsu.js"; //江苏省数据js
import "echarts/map/js/province/hunan.js"; //湖南省数据js
import "echarts/map/js/province/yunnan.js"; //云南省数据js
import "echarts/map/js/province/hebei.js"; //河北省数据js
import "echarts/map/js/province/guizhou.js"; //贵州省数据js

// 江西  四川  江苏  湖南   云南
export default {
  name: "hr24",
  data() {
    return {
      data_change_is:true,
      map_top: {},
      agent_type: 0, //0是市代，1是省代
      order: "pay_charge",
      bill_loading: true,
      grid_loading:true,
      user_data: "0",
      index: 0,
      show1: true,
      show2: true,
      time: "",
      mapData: [],
      data1: [
        {
          title: "零工客户总数",
          value: 0,
          type: "all_counts",
          src: "all_counts",
        },
        {
          title: "发布需求总数量",
          value: 0,
          type: "jd_cost_count",
          src: "jd_cost_count",
        },
        {
          title: "到期零工客户数",
          value: 0,
          type: "expire_count",
          src: "expire_count",
        },
        {
          title: "正常零工客户数",
          value: 0,
          type: "not_expire_count",
          src: "not_expire_count",
        },
      ],
      data2: [
        {
          title: "今日企业注册",
          value: 0,
          type: "odd_company_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "今日需求发布",
          value: 0,
          type: "jd_cost_count",
          id: 1,
          src: "download_resume",
        },
        {
          title: "今日零工身份证认证",
          value: 0,
          type: "id_auth_count",
          id: 1,
          src: "send_resume",
        },
        {
          title: "今日零工健康证认证",
          value: 0,
          type: "health_count",
          id: 2,
          src: "create_jd",
        },
      ],
      data_mon: [
        {
          title: "30日企业注册",
          value: 0,
          type: "odd_company_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "30日需求发布",
          value: 0,
          type: "jd_cost_count",
          id: 1,
          src: "download_resume",
        },
        {
          title: "30日身份证认证数",
          value: 0,
          type: "id_auth_count",
          id: 1,
          src: "send_resume",
        },
        {
          title: "30日零工健康证认证",
          value: 0,
          type: "health_count",
          id: 2,
          src: "create_jd",
        },
      ],
      billData: [],
      resume_count_city: [],
      timeer: {},
      today_data: 0,
      is_pro_agent: true,
      picker_tabs: "",
      beal: true,
    };
  },
  created() {},
  mounted() {
    this.ten_fun();
    // this.timeer = setInterval(() => {
    //   this.index++;
    //   if (this.index % 30 == 0) {
    //     // this.ten_fun()
    //   }
    //   console.log("index");
    // }, 1000);
    // this.echarts()
  },
  methods: {
    // 地图上方数据
    odd_work_data() {
      this.grid_loading = true;
      require("post", "/hrswork_index_data/v1/odd_work_data/").then((res) => {
        if (!res.code) {
          this.map_top = res.data;
          this.grid_loading = false;
        }
      });
    },
    // 排行榜排序
    listsort(val) {
      this.bill_loading = true;
      var date = new Date();
      let year = date.getFullYear(); //获取完整的年份(4位)
      let mouth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      // let date1 = new Date(`${year}-${mouth}-1`).getTime();
      this.order = val;

      let obj = {};
      if (this.picker_tabs != "") {
        var ismonth = new Date(this.picker_tabs).getMonth() + 1;
        var isyear = new Date(this.picker_tabs).getFullYear();
        console.log(isyear, ismonth.toString().padStart(2, "0"));
        obj = {
          year: isyear,
          month: ismonth,
          order: this.order,
          agent_type: this.agent_type,
        };
      } else {
        obj = {
          year: year,
          month: mouth.toString().padStart(2, "0"),
          order: this.order,
          agent_type: this.agent_type,
        };
      }
      this.is_pro_agent = this.beal;
      if (this.beal) {
        require("post", "/hrswork_index_data/v1/odd_ranking_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.billData = [];
              this.billData = res.data.agent_list;
              this.bill_loading = false;
            }
          }
        );
      } else {
        obj.is_province_agent = 1;
        require("post", "/hrswork_index_data/v1/odd_ranking_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.billData = [];
              this.billData = res.data.agent_list;
              this.bill_loading = false;
            }
          }
        );
      }
    },

    //获取当前时间
    writeCurrentDate() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var week;
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;

      var arr_week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      week = arr_week[day];

      this.time =
        year +
        "年" +
        month +
        "月" +
        date +
        "日" +
        " " +
        hour +
        ":" +
        minu +
        ":" +
        sec +
        " " +
        week;
      //设置得到当前日期的函数的执行间隔时间，每1000毫秒刷新一次。
    },
    //地图
    mapFun(data) {
      let obj = {
        textStyle: {
          color: "#ff0000",
          fontSize: 15.67,
        },
        color: ["#F0AA16"], //手动设置每个图例的颜色
        tooltip: {
          // trigger: 'item',
          formatter: function (params) {
            var percent = 0;
            var total = 0;
            for (var i = 0; i < data.length; i++) {
              if (params.name == data[i].name) {
                if (params.name !== "") {
                  return params.name + " \n " + data[i].value;
                } else {
                  return "";
                }
              }
            }
          },
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          x: "right",
          y: "center",
        },
        roamController: {
          show: true,
          x: "right",
          mapTypeControl: {
            china: true,
          },
        },
        series: [
          {
            name: "用户数量",
            type: "map",
            // map: 'china',
            mapType: "china",
            roam: false,
            left: "0%",
            top: "0%",
            // zoom: 1,
            // center: [95, 45.71],
            // aspectScale:1,
            label: { show: true },
            itemStyle: {
              color: "#162858",
              borderColor: "#48CFFC",
              normal: {
                label: {
                  show: false,
                },
                areaColor: "#162858",
                borderColor: "#2A4C68 ",
                borderWidth: 1,
              },
              emphasis: {
                label: {
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: "bold",
                },
                itemStyle: {
                  color: "#0f0",
                },
              },
            },
            data,
          },
        ],
      };
      if (this.$cookies.get("auth_grade") == 90) {
        obj.series[0].mapType =
          this.$cookies.get("agent_province_name") || "china";
      } else {
        obj.series[0].center = [95, 45.71];
      }
      //地图
      console.log(this.$refs.map_data, "地图");
      this.$echarts.init(this.$refs.map_data).setOption(obj);
      // this.three_fun()
    },
    //身份证认证
    resumeFun(data) {
      console.log("jianli", this.$refs.echarts_resume);
      let arr = [];
      let arr1 = [];
      data.map((item) => {
        arr.push(item.city_count);
        arr1.push(item.city_name);
      });
      this.$echarts.init(this.$refs.echarts_resume).setOption({
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFA500", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "blue", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {},
        xAxis: {
          type: "category",
          // boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          data: arr1,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
        },
        series: [
          {
            name: "认证总数",
            type: "bar",
            stack: "总量",
            backgroundStyle: {
              color: "rgb(50, 199, 245)",
            },
            data: arr,
          },
        ],
      });
    },
    //健康证认证
    radarFun(data) {
      console.log("leida ", this.$refs.echarts_rader);
      let arr = [];
      let arr1 = [];
      data.map((item) => {
        arr.push(item.city_count);
        arr1.push(item.city_name);
      });
      this.$echarts.init(this.$refs.echarts_rader).setOption({
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#d1f532", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "blue", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          data: arr1,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
        },
        series: [
          {
            name: "认证总数",
            type: "bar",
            stack: "总量",
            lineStyle: {},
            backgroundStyle: {
              color: "#FFA500",
            },
            data: arr,
          },
        ],
      });
    },
    //今日数据
    todayFun(data) {
      console.log(data, "aaaaaaaaaa");
      let arr = [];
      data.map((item, index) => {
        arr.push(item.value);
      });
      this.$echarts.init(this.$refs.today_data).setOption({
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "red", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "blue", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        xAxis: {
          type: "category", //类目
          axisTick: {
            show: true,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            rotate: -20, //字体旋转
          },
          nameTextStyle: { color: "#fff" },

          markPoint: {
            //图形标注
            show: true,
          },
          data: ["企业注册", "需求发布", "身份证认证数", "零工健康证认证"],
        },
        yAxis: {
          splitLine: {
            //横向坐标轴
            show: false,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          itemStyle: {
            //柱状折线拐点标志的样式。
          },
          type: "value",
        },

        series: [
          {
            itemStyle: {
              //上方显示数值
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#0ff",
                    fontSize: 16,
                  },
                },
              },
            },
            data: arr,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      });
    },
    //30日数据
    mouthFun(data) {
      let arr = [];
      data.map((item, index) => {
        arr.push(item.value);
      });
      this.$echarts.init(this.$refs.mouth_data).setOption({
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#5d9ef3", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#aaa", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        xAxis: {
          type: "category", //类目
          axisTick: {
            show: true,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            rotate: -20, //字体旋转
          },
          nameTextStyle: { color: "#fff" },

          markPoint: {
            //图形标注
            show: true,
          },
          data: ["企业注册", "需求发布", "身份证认证数", "零工健康证认证"],
        },
        yAxis: {
          splitLine: {
            //横向坐标轴
            show: false,
          },
          axisLabel: {
            color: "#fff", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          itemStyle: {
            //柱状折线拐点标志的样式。
          },
          type: "value",
        },

        series: [
          {
            itemStyle: {
              //上方显示数值
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#0ff",
                    fontSize: 16,
                  },
                },
              },
            },
            data: arr,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      });
    },
    userFun(data) {
      let arr = [];
      let arr1 = [];
      data.map((item) => {
        let filter = ["到期客户", "正常客户"];
        if (filter.indexOf(item.title) == -1) {
          arr.push({
            name: item.title,
            value: item.value,
          });
        } else {
          arr1.push({
            name: item.title,
            value: item.value,
          });
        }
      });
      this.$echarts.init(this.$refs.user_staus).setOption({
        // title: {
        //   text: '某站点用户访问来源',
        //   subtext: '纯属虚构',
        //   left: 'center',
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        //   data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎'],
        // },
        width: "90%",

        series: [
          {
            name: "客户分类",
            type: "pie",
            radius: ["0%", "30%"],
            // center: ['50%', '50%'],
            selectedMode: "single",
            data: arr1,
            labelLine: {
              show: false,
            },
            // itemStyle: {
            //   //上方显示数值
            //   normal: {
            //     label: {
            //       show: true, //开启显示
            //       position: 'outside', //在上方显示
            //     },
            //   },
            // },
            label: {
              show: true,
              position: "inner",
              formatter: `{b} \n {d}%`,
            },
          },
          {
            name: "客户分类",
            type: "pie",
            radius: ["40%", "50%"],
            center: ["50%", "50%"],
            data: arr,
            itemStyle: {
              //上方显示数值
              normal: {
                label: {
                  show: true, //开启显示
                  position: "outside", //在上方显示
                  formatter: `{b} \n {c}`,
                },
              },
            },
            label: {
              show: true,
              position: "outside",
              formatter: `{a}`,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    ten_fun() {
      this.odd_work_data();
      //用户数据变化
      //所有用户
      //地图
      // if (this.$cookies.get("auth_grade") == 100) {
      //   require("post", "/hr24_index_data/v1/admin_user_data/", {}).then(
      //     (res) => {
      //       if (!res.code) {
      //         let data = res.data;
      //         this.mapData = [];
      //         this.user_data = Number(res.user_count) + "";
      //         console.log(this.user_data);
      //         for (let item in data) {
      //           this.mapData.push({
      //             name: item,
      //             value: data[item],
      //           });
      //         }
      //         console.log(this.mapData);
      //         this.$nextTick(() => {
      //           this.mapFun(this.mapData);
      //         });
      //       }
      //     }
      //   );
      // }

      let url_data_mon = ""; //30日数据
      let echarts_url_rr = ""; //简历雷达
      if (this.$cookies.get("auth_grade") == 100) {
        url_data_mon = "/hrswork_index_data/v1/all_month_data/";
        echarts_url_rr = "/hrswork_index_data/v1/odd_auth_city/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        echarts_url_rr = "/hrswork_index_data/v1/odd_auth_city/";
        url_data_mon = "/hrswork_index_data/v1/all_month_data/";
      }
      require("post", echarts_url_rr, {}).then((res) => {
        if (!res.code) {
          this.resume_count_city = [];
          this.radar_count = [];
          this.resume_count_city = res.data.odd_id_card_list;
          this.radar_count = res.data.odd_health_list;
          console.log(this.resume_count_city);

          this.$nextTick(() => {
            if (this.show1) {
              this.resumeFun(this.resume_count_city);
            } else {
              this.radarFun(this.radar_count);
            }
          });
        }
      });
      let data1_url = ""; //数值data1数据接口,页面右侧第一种
      let data2_url = ""; //数值data2数据接口,页面右侧第二种

      if (this.$cookies.get("auth_grade") == 80) {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
        data2_url = "/hrswork_index_data/v1/one_month_data/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
        data2_url = "/hrswork_index_data/v1/one_month_data/";
      } else {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
        data2_url = "/hrswork_index_data/v1/one_month_data/";
      }
      let obj = {};
      // if (this.$cookies.get('auth_grade') == 80) {
      //   require('post', '/hr24_index_data/v1/agent_day_statistics/', obj).then(
      //     (res) => {
      //       if (!res.code) {
      //         this.agent_login_data.map((item, index) => {
      //           let prop = item.type
      //           item.value = res.data[prop]
      //         })
      //       }
      //     }
      //   )
      // }
      require("post", data1_url, obj).then((res) => {
        if (!res.code) {
          this.data1.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop] || 0;
          });
          this.$nextTick(() => {
            this.userFun(this.data1);
          });
          if (this.$cookies.get("auth_grade") == 90) {
            let data = res.data.use_place_data;
            this.mapData = [];
            this.user_data = Number(res.data.use_counts) + "";
            console.log(this.user_data);
            for (let item in data) {
              this.mapData.push({
                name: item,
                value: data[item],
              });
            }
            console.log(this.mapData);
            this.$nextTick(() => {
              this.mapFun(this.mapData);
            });
          }
        }
      });
      require("post", url_data_mon, obj).then((res) => {
        if (!res.code) {
          console.log(res, "月总数");
          this.data_mon.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop];
          });
          // if (this.$cookies.get("auth_grade") == 90) {
          //   this.mouthFun(this.data_mon);
          // }
          this.mouthFun(this.data_mon);
        }
      });
      require("post", data2_url, obj).then((res) => {
        if (!res.code) {
          if (
            this.$cookies.get("auth_grade") == 100 ||
            this.$cookies.get("auth_grade") == 90
          ) {
            this.data2.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop] || 0;
            });
            this.$nextTick(() => {
              this.todayFun(this.data2);
            });
          }
        }
      });
      this.beal = true;
      this.agent_change();
    },
    show_change(beal) {
      console.log(beal);
      this.show1 = beal;
      if (this.show1) {
        this.$nextTick(() => {
          this.resumeFun(this.resume_count_city);
        });
      } else {
        this.$nextTick(() => {
          this.radarFun(this.radar_count);
        });
      }
    },
    agent_change(val) {
      if (val != undefined) {
        this.agent_type = val;
      }
      this.bill_loading = true;
      var date = new Date();
      let year = date.getFullYear(); //获取完整的年份(4位)
      let mouth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      let date1 = new Date(`${year}-${mouth}-1`).getTime();

      let obj = {};
      if (this.picker_tabs != "") {
        var ismonth = new Date(this.picker_tabs).getMonth() + 1;
        var isyear = new Date(this.picker_tabs).getFullYear();
        console.log(isyear, ismonth.toString().padStart(2, "0"));
        obj = {
          year: isyear,
          month: ismonth,
          order: this.order,
          agent_type: this.agent_type,
        };
      } else {
        obj = {
          year: year,
          month: mouth.toString().padStart(2, "0"),
          order: this.order,
          agent_type: this.agent_type,
        };
      }
      this.is_pro_agent = this.beal;
      if (this.beal) {
        console.log(obj);
        require("post", "/hrswork_index_data/v1/odd_ranking_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.billData = [];
              this.billData = res.data.agent_list;
              this.bill_loading = false;
            }
          }
        );
      } else {
        // obj.is_province_agent = 1;
        require("post", "/hrswork_index_data/v1/odd_ranking_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.billData = [];
              this.billData = res.data.agent_list;
              this.bill_loading = false;
            }
          }
        );
      }
    },

    data_change(beal) {
      this.data_change_is = beal;
      this.show2 = beal;
      if (this.show2) {
        this.$nextTick(() => {
          this.todayFun(this.data2);
        });
      } else {
        this.$nextTick(() => {
          this.mouthFun(this.data_mon);
        });
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timeer);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  scoped >
html /deep/ body {
  padding: 0px 0px 0px 0px;
}
.daData {
  margin: -30px -50px -50px;
  background: #142132;
  margin-bottom: 12px;
  overflow: auto;
  position: relative;
  min-height: 1000px;
}
.display_flex {
  display: flex;
  margin-bottom: 10px;
}
.display_flex > div {
  width: 50%;
  margin: 10px;
}
.today_data,
.resume_rader {
  width: 30%;
  height: 100%;
  /* background: chocolate; */
}
.today_data {
  float: left;
}
.resume_rader {
  float: right;
}
.map {
  width: 40%;
  float: left;
  /* background: lightblue; */
}
.title {
  text-align: center;
  padding: 12px 30px;
  font-size: 45px;
  margin: 20px;
  color: aliceblue;
  font-weight: bolder;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  margin-bottom: 30px;
}
.map_item {
  width: 500px;
  height: 500px;
  margin: auto;
  /* border: 1a264ed1 solid 1px; */
  /* background: url(../../static/img/daData/aaa.png) no-repeat;
  background-size: 100%; */
  /* box-shadow: inset rgb(3, 3, 93) 1px 1px 20px 0px; */
  border-radius: 20px;
}
.grid-content{
  display: flex;
  flex-wrap: wrap;
}
.user_data {
  width: 33%;
  margin-top: 20px;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  text-align: center;
  overflow: hidden;
}
.user_data > p{
  color: #ffa550;
  font-size: 24px;
}

.user_data > span {
  font-size: 60px;
  padding: 0 12px;
  margin: 20px 6px 0;
  background: lightcyan;
}
.echarts_rr {
  width: 100%;
  /* overflow-x: auto; */
}
.echarts_rr_item {
  width: 380px;
  margin: auto;
  height: 400px;
}
.today_1 > p {
  margin: 0px 0;
  font-size: 14px;
  padding: 12px 6px;
  /* letter-spacing: 8px; */
}
.today_1 > .today_echart {
  width: 100%;
  margin: auto;
  height: 400px;
}
.resume_radera {
  /* width: 98%; */
  margin: auto;
  /* background: #1e2e3e;  */
  color: rgb(238, 237, 237);
  /* margin-top: 10%; */
  /* position: absolute;
  bottom: 0; */
  /* border: #142132 solid 1px; */
}
.resume_radera > p {
  text-align: center;
  margin: 0px 0;
  font-size: 26px;
  font-weight: initial;
  padding: 12px 6px;
  letter-spacing: 8px;
}
.conent {
  overflow-x: auto;
}
.conent > .today_echart {
  width: 100%;
  margin: auto;
  height: 400px;
}
.today_tabs {
  text-align: center;
  font-size: 14px;
  padding-bottom: 12px;
  border-bottom: #5d9ef3 solid 1px;
}
.today_tabs > span {
  padding: 12px 12px;
  cursor: pointer;
  color: #5d9ef3;
}
.city {
  height: 400px;
  padding: 12px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
}
.city > div {
  width: 100%;
  height: 100%;
}
.grid {
  width: 80%;
  margin: auto;
  background: #1e2e3e;
  color: rgb(238, 237, 237);
  margin-top: 10%;
}
.time {
  padding: 12px;
  text-align: right;
  font-size: 25px;
  color: #ffffff;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
}
.title_dan {
  text-align: center;
}
.bill {
  width: 100%;
  margin: auto;
  height: 428px;
  background: rgba(30, 46, 62, 0.5);
  overflow-y: auto;
  border-radius: 12px 12px 0px 0px;
  margin-bottom: 20px;
}

.tr {
  font-size: 15px;
  color: #fff;
  overflow: hidden;
  border-bottom: #f5c43e solid 1px;
  display: flex;
}
.tr > span {
  display: block;
  flex: 1;
  /* float: left; */
  /* width: 20%; */
  text-align: center;
  padding: 6px 0;
}

.billl {
  height: 394px;
  overflow: auto;
}
.bill_item {
  color: rgb(214, 213, 213);
  overflow: hidden;
  font-size: 14px;
  padding: 4px 0;
  cursor: pointer;
  display: flex;
}
.billl > .bill_item:nth-of-type(1) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.billl > .bill_item:nth-of-type(2) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.billl > .bill_item:nth-of-type(3) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.bill_item > p {
  margin: 0px;
  flex: 1;
  /* float: left; */
  /* width: 20%; */
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bill_pro {
  width: 100%;
  margin: auto;
  height: 428px;
  background: rgba(30, 46, 62, 0.5);
  overflow-y: auto;
  border-radius: 12px 12px 0px 0px;
  margin-bottom: 20px;
}

.tr_pro {
  font-size: 16px;
  color: #fff;
  overflow: hidden;
  border-bottom: #f5c43e solid 1px;
}
.tr_pro > span {
  display: block;
  float: left;
  width: 33.3%;
  text-align: center;
  padding: 6px 0;
}

.billl_pro {
  height: 394px;
  overflow: auto;
}
.bill_item_pro {
  color: rgb(214, 213, 213);
  overflow: hidden;
  font-size: 14px;
  padding: 4px 0;
  cursor: pointer;
}
.billl_pro > .bill_item_pro:nth-of-type(1) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.billl_pro > .bill_item_pro:nth-of-type(2) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.billl_pro > .bill_item_pro:nth-of-type(3) {
  color: rgb(252, 117, 7);
  font-size: 16px;
  font-weight: 600;
  padding: 4px 0;
}
.bill_item_pro > p {
  margin: 0px;
  float: left;
  width: 33.3%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.echarts_r_r {
  /* width: calc(100% - 820px); */
  margin: auto;
}
.elite > .title {
  text-align: center;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 24px;
  color: #d1f532;
}
.map_data {
  display: flex;
  flex-wrap: wrap;
}
.map_data div {
  width: 33%;
  color: #fc7507;
  line-height: 30px;
  display: flex;
}
.map_data div .first {
  width: 60%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.map_data div .two {
  width: 40%;
}
.data_change_color{
  color:#ffa500 !important
}
</style>



// WEBPACK FOOTER //
// src/components/daData/oddjobHR24.vue